
<template>
  <div>
    <b-container fluid="lg">
      <b-row>
        <b-col>
          <b-card>
            <div class="text-center mb-3">
              <img class="mb-3 logo" src="/imgs/logoAbelha.png" alt="" />
            </div>
            <b-skeleton-wrapper :loading="firstLoading">
              <template #loading>
                <b-card>
                  <b-row>
                    <b-skeleton width="100%"></b-skeleton>
                  </b-row>
                  <b-row class="mt-3">
                    <b-skeleton height="40%" width="100%"></b-skeleton>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col>
                      <b-skeleton type="input" width="50%"></b-skeleton>
                    </b-col>
                    <b-col>
                      <b-skeleton type="input" width="50%"></b-skeleton>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col>
                      <b-skeleton type="input" width="50%"></b-skeleton>
                    </b-col>
                    <b-col>
                      <b-skeleton type="input" width="50%"></b-skeleton>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col>
                      <b-skeleton-img width="50%"></b-skeleton-img>
                    </b-col>
                    <b-col>
                      <b-skeleton-img width="50%"></b-skeleton-img>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-skeleton width="100%"></b-skeleton>
                  </b-row>
                </b-card>
              </template>
              <template v-if="!firstLoading">
                <div class="text-center mt-3" v-if="data.distribuidor">
                  <h2 class="mt-3 distribuidor">
                    Olá {{ data.distribuidor.nome }}
                  </h2>
                </div>
                <h5 class="mt-3 mb-3 title">
                  <b>
                    Estamos em período de solicitação de catálogos para a campanha {{ data.campanha }}
                  </b>
                </h5>
                <b-row class="mt-3 mb-3" v-if="data.distribuidor">
                  <h6>
                    Código do Distribuidor: {{ data.distribuidor.codigo }}
                  </h6>
                </b-row>
                <b-row>
                  <b-col>
                    <b-card>
                      <span>*</span> Quantidade de Catálogos:
                      <b-form-input
                        class="mt-3"
                        v-mask="['##########']"
                        v-model="data.quantidade"
                        placeholder="Quantidade"
                      ></b-form-input>
                      <b-form-text id="input-live-help"
                        >O valor do frete é calculado a partir da quantidade de
                        catálogos!</b-form-text
                      >
                    </b-card>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="text-center">
                    <b>Atenção! Todas solicitações passará por análise de aproveitamento!</b>
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                  <b-button
                    :disabled="loading"
                    variant="success"
                    @click="salvar()"
                  >
                    <b-spinner
                      small
                      v-if="loading"
                      label="Loading..."
                    ></b-spinner>
                    <i class="fas fa-save" v-else></i>
                    Salvar
                  </b-button>
                </b-row>
              </template>
            </b-skeleton-wrapper>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { text } from '@fortawesome/fontawesome-svg-core';

export default {
  data() {
    return {
      data: {
        quantidade: "",
        distribuidor: {
          nome: "",
        },
      },
      loading: false,
      firstLoading: true,
      loading: false,
      erros: [],
      cpf: "",
    };
  },
  methods: {
    salvar() {
      const vm = this;

      if (parseInt(vm.data.quantidade) < 0) {
        vm.$swal.fire({
          title: "Atenção!",
          icon: "error",
          text: "Informe a quantidade de catálogos para envio ou zero para não enviar catálogo",
        });
        return;
      }
      vm.$swal.fire({
        icon: 'question',
        title: "Confirma a quantidade de catálogos?",
        html: this.data.quantidade +  "Catálogos  <br> <br> Enviar no mínimo 3 itens por catálogo recebido mensalidade!",
        footer: "Esta ação não poderá ser revertida!",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Sim, Confirmo",
        denyButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          vm.loading = true;
          const data = {
            'operacao': vm.data.id,
            'quantidade': vm.data.quantidade,
            'distribuidor': vm.data.distribuidor.id
          };          
          axios
            .post("/distribuidor/operacao-catalogo/" + vm.data.id, data)
            .then((response) => {
              //console.log(response);
              window.location.reload();
            })
            .catch((erro) => {
              console.log(erro.response);
              if(erro.response.data && typeof(erro.response.data) == 'string') {
                vm.$swal.fire({
                  title: "Atenção!",
                  icon: "warning",
                  text: erro.response.data,
                });
                return;
              }
              vm.$swal.fire({
                title: "Atenção!",
                icon: "error",
                text: "Erro ao salvar dados!",
              });
            })
            .finally(() => {
              vm.loading = false;
            });
        }
      });
    },
  },
  mounted() {
    this.data = JSON.parse(document.getElementById("dataCatalogo").value);
    this.firstLoading = false;
  },
};
</script>

<style>
button {
  width: 100%;
  background-color: #4caf50;
  color: white;
  padding: 14px 20px;
  margin: 8px 0;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
button:hover {
  background-color: #45a049;
  box-shadow: black;
}
span {
  color: red;
}

@media (max-width: 1000px) {
  .logo {
    display: none;
  }

  .title {
    text-align: justify;
    font-size: 18px;
  }

  .distribuidor {
    text-align: center;
    font-size: 20;
  }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/distribuidor/Home/OperacaoCatalogo.vue